<div class="year-grid-container" (click)="closePopover()">
  <!-- Month labels row -->
  <div class="month-labels-row">
    <div class="day-label-spacer"></div>
    <div class="months-track">
      @for (month of monthLabels; track month) {
        <div
          class="month-label"
          [style.gridColumnStart]="month.colStart + 1"
          [style.gridColumnEnd]="'span ' + month.colSpan"
          >
          {{ month.label }}
        </div>
      }
    </div>
  </div>

  <!-- Grid body -->
  <div class="grid-body">
    <div class="day-labels">
      @for (day of dayLabels; track day; let i = $index) {
        <span class="day-label" [class.weekend]="i >= 5">
          {{ day }}
        </span>
      }
    </div>

    <div class="grid-cells" [style.gridTemplateColumns]="'repeat(' + totalWeeks + ', 11px)'">
      @for (row of grid; track trackByRow(rowIdx, row); let rowIdx = $index) {
        @for (week of [].constructor(totalWeeks); track trackByWeek(colIdx, week); let colIdx = $index) {
          <div
            class="grid-cell"
            [ngClass]="getCellClass(grid[rowIdx][colIdx])"
            [style.gridRow]="rowIdx + 1"
            [style.gridColumn]="colIdx + 1"
            [style.backgroundColor]="getCellColor(grid[rowIdx][colIdx])"
            [title]="showPopover ? '' : getCellTooltip(grid[rowIdx][colIdx])"
            (click)="onCellClick(grid[rowIdx][colIdx], $event)"
          ></div>
        }
      }
    </div>
  </div>

  <!-- Legend -->
  <div class="legend">
    <div class="legend-item">
      <span class="legend-swatch" style="background: #FFFFFF; border: 1px solid #E9ECF4;"></span>
      <span class="legend-label">Workday</span>
    </div>
    <div class="legend-item">
      <span class="legend-swatch" style="background: #E9ECF4;"></span>
      <span class="legend-label">Weekend</span>
    </div>
    <div class="legend-item">
      <span class="legend-swatch" style="background: #1036D6;"></span>
      <span class="legend-label">Holiday</span>
    </div>
    <div class="legend-item">
      <span class="legend-swatch" style="background: #E02020;"></span>
      <span class="legend-label">Moratorium</span>
    </div>
    <div class="legend-item">
      <span class="legend-swatch" style="background: #FA6400;"></span>
      <span class="legend-label">Weather</span>
    </div>
    <div class="legend-item">
      <span class="legend-swatch" style="background: #8B94B3;"></span>
      <span class="legend-label">Suspension</span>
    </div>
    <div class="legend-item">
      <span class="legend-swatch org-inherited-swatch" style="background: #1036D6;"></span>
      <span class="legend-label">Org inherited</span>
    </div>
  </div>

  <!-- Cell popover -->
  @if (showPopover && activeCell) {
    <div
      class="cell-popover"
      [style.top.px]="popoverPosition.top"
      [style.left.px]="popoverPosition.left"
      (click)="$event.stopPropagation()"
      >
      <div class="popover-header">
        {{ activeCell.date.format('ddd, MMM D, YYYY') }}
      </div>
      @if (activeCell.holiday) {
        <div class="popover-holiday-info">
          <span class="holiday-name" [title]="activeCell.holiday.name">{{ activeCell.holiday.name }}</span>
          <span class="holiday-type-badge" [ngClass]="'type-' + activeCell.holiday.type">
            {{ activeCell.holiday.type | titlecase }}
          </span>
          @if (activeCell.isOrgHoliday) {
            <span class="org-badge">Org</span>
          }
        </div>
      }
      <div class="popover-actions">
        @if (!activeCell.holiday) {
          <button mat-button color="primary" (click)="onAddHoliday()">
            <mat-icon>add</mat-icon> Add holiday
          </button>
        }
        @if (activeCell.holiday && !activeCell.isOrgHoliday) {
          <button mat-button color="primary" (click)="onEditHoliday()">
            <mat-icon>edit</mat-icon> Edit
          </button>
        }
        @if (activeCell.holiday) {
          <button mat-button color="warn" (click)="onRemoveHoliday()">
            <mat-icon>delete</mat-icon> Remove
          </button>
        }
      </div>
    </div>
  }
</div>
